import { useCurrentWorkspace } from "@accurx/auth";
import { Ds } from "@accurx/design";
import { getCreatePagePath } from "domains/appointment-reminders/Routes";
import { useHistory } from "react-router-dom";

export function CreateReminderButton() {
    const { orgId } = useCurrentWorkspace();
    const history = useHistory();

    return (
        <Ds.Button onClick={() => history.push(getCreatePagePath(orgId))}>
            <Ds.Button.Icon name="Plus" />
            Create appointment reminder
        </Ds.Button>
    );
}
